export default "__VITE_ASSET__BtV4D0lZ__"